module.exports = __webpack_public_path__ + "static/assets/f6239cb70e7784e9ddb7843dc761d1c5.gif";